
import { Component, Vue, Watch } from "vue-property-decorator";
import { checkioTypes } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
@Component({
  name: "Form1",
  components: {},
  props: {
    callbackdata: {
      type: Object,
      default: false,
    },
  },
  watch: {
    callbackdata(newone, oldone) {
      if (newone.input_CarSignNum != this.inputModel.input_CarSignNum) {
        this.inputModel = newone;
      } else if (
        newone.input_SignatureStatue != this.inputModel.input_SignatureStatue
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_MidSignatureNum != this.inputModel.input_MidSignatureNum
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_LastSignatureNum != this.inputModel.input_LastSignatureNum
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_ReasonForSignatureStatue !=
        this.inputModel.input_ReasonForSignatureStatue
      ) {
        this.inputModel = newone;
      }
    },
  },
})
export default class extends Vue {
  private inputModel: inputDataModel_ResolveCar = {
    input_ScanCode: "",
    input_CarSignNum: "",
    input_SignatureStatue: "",
    input_MidSignatureNum: "",
    input_LastSignatureNum: "",
    input_ReasonForSignatureStatue: "",
  };
  public Options_SignatureStatue = [
    // {
    //   value: "选项1",
    //   label: "完好",
    // },
  ];
  public globalConfig: any = {};
  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    // this.$emit("get-form1-value", this.inputModel);
    debugger;
    let resuest = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        queryValue: "1",
        queryType: "7",
        viewType: "1",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    let responseStr = checkioTypes(JSON.stringify(resuest));
    let response = JSON.parse(responseStr);
    if (response != null && response.respcode == "000") {
      this.CheckIoTypeCallBack(response.data);
    } else {
      this.$message.error("查询铅封状态返回错误:" + response.respMessage);
    }
    console.log(response);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  public CheckIoTypeCallBack(data) {
    if (data == null) {
      LogHelper.WriteLog("初始化时，查询铅封状态，回传的data为空");
      return;
    }
    let ioTypes_Array_Datas = [];
    try {
      var m_IntVolumnWeightDenominator = Number.parseFloat(data.queryNo);
      LogHelper.WriteLog(
        "当前得到的体积系数为 ： " + m_IntVolumnWeightDenominator
      );
    } catch (error) {}
    if (data.busiDataArray != null && data.busiDataArray.length > 0) {
      ioTypes_Array_Datas = [];
      for (var iIndex = 0; iIndex < data.busiDataArray.length; iIndex++) {
        ioTypes_Array_Datas.push(data.busiDataArray[iIndex].value);
      }
    }
    if (ioTypes_Array_Datas != null && ioTypes_Array_Datas.length > 0) {
      this.Options_SignatureStatue = ioTypes_Array_Datas.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
      this.inputModel.input_SignatureStatue = "完好";
    } else {
      this.Options_SignatureStatue = [];
      this.inputModel.input_SignatureStatue = "";
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    // this.$refs.singleTable.setCurrentRow(row);
    this.$refs.singleTable[0].setCurrentRow();
  }

  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
}
